// High Level: Receive as props a position, company, etc. type resume listing, and return a
// card for displaying the data within the relevant experience section.

import React from 'react'
import './ResumePosition.css'

function ResumePostion(props) {
  const data = props.props
  return (
    <div className='text-center my-4 resume-position-div'>
      <h6>{data.title}</h6>
      <div className='text-muted'>
        {data.company} - {data.location}
      </div>
      <div className='fst-italic'>{data.dates}</div>
      <ul className='resume-position-list'>
        {data.bullets.map((bullet, key) => {
          return (
            <li key={key} className='list-item text-start'>
              {bullet}
            </li>
          )
        })}
      </ul>
      <hr></hr>
    </div>
  )
}

export default ResumePostion
